import { FunctionComponent } from "react";
import { Container } from "../../../../components/formulario/styled";
import HeaderCRM from "./header";
import TabelaListaCRM from "./tabela";


interface ContainerCRMProps {

}

const ContainerCRM: FunctionComponent<ContainerCRMProps> = () => {
  return ( <>
    <Container>
      <HeaderCRM/>
      <TabelaListaCRM/>
    </Container>
  </>  );
}

export default ContainerCRM;
